import { useEffect, useCallback, useMemo } from 'react';
import WebSocketManager from '../../../ws/client';

export function useReservationUpdates({ clientCode, responsibleId, setAllReservations }) {
    const topic = useMemo(() => {
        if (!clientCode) return null;
        return `/topic/clients/${clientCode}/reservations`;
    }, [clientCode]);

    const handleMessage = useCallback((event) => {
        try {
            const { type, payload } = event;

            setAllReservations(prev => {
                // For parent mode: only apply if this reservation belongs to this responsible
                if (responsibleId && payload.responsibleId !== responsibleId) return prev;

                switch (type) {
                    case 'CREATED':
                        if (prev.some(r => r.reservationId === payload.reservationId)) return prev;
                        return [payload, ...prev];

                    case 'UPDATED':
                    case 'CANCELED':
                    case 'RELEASED':
                        return prev.map(r => r.reservationId === payload.reservationId ? payload : r);

                    default:
                        return prev;
                }
            });
        } catch (e) {
            console.error('Erro processando WS de reservas:', e);
        }
    }, [setAllReservations, responsibleId]);

    useEffect(() => {
        if (!topic) return;
        WebSocketManager.subscribe(topic, handleMessage);
        return () => WebSocketManager.unsubscribe(topic);
    }, [topic, handleMessage]);
}
